/*jshint multistr: true */
angular.module('picmonicng').directive('plsPaeBanner', [
  function () {
    return {
      restrict: 'E',
      scope: {},
      controller: [
        '$scope',
        '$interval',
        'UserService',
        '$cookies',
        function ($scope, $interval, UserService, $cookies) {
          var interval;
          $scope.show =
            !$cookies.get('pls_hide_fae_banner') &&
            UserService.user.premium_expiration &&
            UserService.user.premium_expiration * 1000 - Date.now() < 608400000;

          $scope.close = function ($event) {
            $event.preventDefault();
            $scope.show = false;
            var expires = new Date();
            expires.setTime(expires.getTime() + 12 * 60 * 60 * 1000);
            $cookies.put('pls_hide_fae_banner', 1, { expires: expires });
          };

          $scope.time = Math.floor((UserService.user.premium_expiration - Date.now() / 1000) / 60);
          if ($scope.show) {
            interval = $interval(function () {
              $scope.time--;
            }, 60000);

            $scope.$on('$destroy', function () {
              if (interval) {
                $interval.cancel(interval);
              }
            });
          }

          $scope.hours = function () {
            return Math.floor($scope.time / 60);
          };

          $scope.minutes = function () {
            return Math.floor($scope.time % 60);
          };
        },
      ],
      template:
        '<a href="/pricing" target="_blank" ng-if="show" atlas-send="extend_access"><div class="notification-banner pls-white pls-font-16 text-center bg-pls-orange p-t-1 p-b-1 p-l-2">\
                            <i class="material-icons pull-right pls-peach m-r-2 m-l-2" ng-click="close($event)">close</i>\
                            Premium access ends in <span class="pls-font-weight-600">{{hours()}} hours and {{minutes()}} minutes</span>. <span class="pls-black pls-font-weight-600"><u>Extend access now!</u></span>\
                        </div></a>',
    };
  },
]);
